import { Box, Chip, Menu, MenuItem } from '@mui/material';
import React from 'react'
import { ocrPalette } from './ocrPalette';
import { Button } from 'antd';

const chipTones = {
    green: { bg: ocrPalette.okBg, color: ocrPalette.ok },
    blue: { bg: ocrPalette.accentBg, color: ocrPalette.accent },
    purple: { bg: ocrPalette.purpleBg, color: ocrPalette.purple },
    gray: { bg: ocrPalette.grayBg, color: ocrPalette.grayText },
};

interface OCRLanguageChipProps {
    label: string;
    tone?: "green" | "blue" | "purple" | "gray";
    languages: string[];
}

const OCRLanguageChip = ({ label, tone = "gray", languages }: OCRLanguageChipProps) => {
    const t = chipTones[tone] || chipTones.gray;
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (languages.length > 1) {
            setAnchorEl(event.currentTarget);
        }
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Box
                component="button"
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                sx={{
                    bgcolor: 'transparent',
                    border: 'none',
                    padding: 0,
                    margin: 0,
                    cursor: languages.length > 1 ? 'pointer' : 'default',
                }}
            >
                <Chip
                    label={label}
                    size="small"
                    sx={{
                        bgcolor: t.bg,
                        color: t.color,
                        fontSize: 12,
                        height: 22,
                        borderRadius: "10px",
                        "& .MuiChip-label": { px: 1.25 },
                    }}
                />
            </Box>
            {
                (languages.length > 1 && open) ? (
                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                    >
                        {
                            languages.map((language, index) => (
                                <MenuItem sx={{ pointerEvents: 'none', pointer: 'default' }} key={language + index}>{language}</MenuItem>
                            ))
                        }
                    </Menu>
                ) : <></>
            }
        </>
    );
}

export default OCRLanguageChip